import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import Image from 'app/Components/Shared/Image/image';
import {stepEnum} from '../Constants/debtPaymentEnum';
import {isMobile} from 'react-device-detect';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import BtnWhiteBlackBorderBigSize from 'app/Components/Shared/Buttons/BtnWhiteBlackBorderBigSize';
import {useBitResultComponent} from '../hooks/useBitResultComponent';
import {selectSelectedBanData, selectPaymentAmount} from '../DebtAndUpdatePaymentBlockSlice';
import {dwhBanReport, DwhActionType, DWHMessageText, DWHStatus} from '../reports/dwhReports';

const BitResultComponent = ({redirectToLobby, logout}) => {
  const {currentStep, actions} = useBitResultComponent();
  const selectedBanData = useSelector(selectSelectedBanData);
  const paymentAmount = useSelector(selectPaymentAmount);
  const loginData = useSelector((state) => state.authentication.loginData);

  useEffect(() => {
    const baseData = {
      banData: selectedBanData,
      loginData,
      paymentAmount,
      actionType: DwhActionType.BitPaymentDetailsPage,
    };
    //general error BIt - backend report
    if (currentStep === stepEnum.BITPAYMENTFAILED) {
      dwhBanReport({...baseData, messageText: DWHMessageText.BitPaymentNotCompletedDisplayed, status: DWHStatus.Ongoing});
    } else if (currentStep === stepEnum.BITPAYMENTIMPOSSIBLE) {
      dwhBanReport({...baseData, messageText: DWHMessageText.BitPaymentNotPossibleDisplayed, status: DWHStatus.Error});
    }
  }, []);

  const resultTitle = () => {
    switch (currentStep) {
      case stepEnum.BITGENERALERROR:
        return `מצטערים, משהו השתבש והתהליך לא הושלם`;
      case stepEnum.BITPAYMENTFAILED:
        return 'מצטערים אבל התשלום <br/> ב- bit לא בוצע';
      case stepEnum.BITPAYMENTIMPOSSIBLE:
        return 'מצטערים אבל לא ניתן לשלם באמצעות bit';
      case stepEnum.BITPENDING:
        return 'ראינו ששילמת באמצעות bit בקרוב יתקבל אישור תשלום גם כאן';
      case stepEnum.INCORRECTUSER:
        return 'זיהינו חיבור לדפדפן עם חשבון אחר מזה שביצע את תשלום החוב';
    }
  };

  const resultText = () => {
    switch (currentStep) {
      case stepEnum.BITGENERALERROR:
        return 'נציגנו יחזור אליך בהקדם האפשרי<br/> כדי לסיים את התהליך';
      case stepEnum.BITPAYMENTFAILED:
        return 'נסה שנית או החלף אמצעי תשלום';
      case stepEnum.BITPAYMENTIMPOSSIBLE:
        return 'אנא החלף אמצעי תשלום';
      case stepEnum.INCORRECTUSER:
        return 'יש להתנתק ולהתחבר עם החשבון עליו בוצע התשלום';
    }
  };

  const getCallback = () => {
    switch (currentStep) {
      case stepEnum.BITGENERALERROR:
        return (
          <div className='callback'>
            <div>מעדיפים להתקשר?</div>
            {isMobile ? (
              <a className='call-btn' href={'tel:*'+ window.Config.technicalSupportPhone}>
                <span>חייגו {window.Config.technicalSupportPhone} לנציג שירות </span>
              </a>
            ) : (
              <div className='call-btn'>חייגו {window.Config.technicalSupportPhone} לנציג שירות </div>
            )}
          </div>
        );
      default:
        return null;
    }
  };

  const getButtons = () => {
    let nextStep;
    switch (currentStep) {
      case stepEnum.BITGENERALERROR:
        return (
          <div className='bit-buttons-wrapper'>
            <BtnSubmit onclick={redirectToLobby} text={'חזרה לעמוד הראשי'} />
          </div>
        );
      case stepEnum.BITPAYMENTFAILED:
        nextStep = stepEnum.SELECTPAYMENTTYPE;
        return (
          <div className='bit-buttons-wrapper'>
            <div className='mb-3'>
              <BtnSubmit onclick={() => actions.goToStep(nextStep)} text={'אני רוצה לנסות שוב'} />
            </div>
            <div>
              <BtnWhiteBlackBorderBigSize text={'לא תודה'} onclick={redirectToLobby} />
            </div>
          </div>
        );
      case stepEnum.BITPAYMENTIMPOSSIBLE:
        nextStep = stepEnum.CREDITCARD;
        return (
          <div className={`bit-buttons-wrapper ${!isMobile ? 'bit-payment-impossible' : ''}`}>
            <BtnSubmit onclick={() => actions.goToStep(nextStep)} text={'לתשלום בכרטיס האשראי'} />
          </div>
        );
      case stepEnum.BITPENDING:
        return (
          <div className='bit-buttons-wrapper'>
            <BtnSubmit onclick={redirectToLobby} text={'חזרה לאיזור האישי'} />
          </div>
        );
      case stepEnum.INCORRECTUSER:
        return (
          <div className='bit-buttons-wrapper'>
            <BtnSubmit onclick={logout} text={'נתקו אותי מהחשבון'} />
          </div>
        );
    }
  };

  return (
    <div className='container-fluid debtpayment-step'>
      <div className={`bit-result ${isMobile ? 'p-0' : ''}`}>
        <div className='content'>
          <div className='s-title-small'>שתלום חוב</div>
          <div className='bit-result-content'>
            <div className='image'>
              {currentStep == stepEnum.BITPENDING ? (
                <Image src={require('../images/clock.svg')} />
              ) : (
                <Image src={require('../images/error-icon.svg')} />
              )}
            </div>
            <div className='bit-result-content-title' dangerouslySetInnerHTML={{__html: resultTitle()}} />
            <div className='bit-result-content-text' dangerouslySetInnerHTML={{__html: resultText()}} />
          </div>

          {getCallback()}
        </div>
        {getButtons()}
      </div>
    </div>
  );
};

export default BitResultComponent;
